// @ts-nocheck
import {
    myAccountHomepageSelectorStyles,
    MyAccountHomepageSelectorStyles,
} from "@insite/content-library/Widgets/MyAccount/MyAccountHomepageSelector";
import { css } from "styled-components";

Object.assign(myAccountHomepageSelectorStyles, {
    checkboxGroup: {
        css: css``,
    },
} as MyAccountHomepageSelectorStyles);
